<template>
    <control label="Discount Rate Options">
        <select v-model="DiscountRatesOptions">
            <option :value="null" disabled hidden>Please select...</option>
            <option value="apply">Apply New Discount Rate</option>
            <option value="applyGenerate">Apply New Discount Rate & Generate Documents</option>
            <option value="generate">Generate Documents with New Discount Rate</option>
        </select>
    </control>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Control from 'components/form/Control.vue';

    export default {
        name: 'discount-rate-options',
        components: {
            Control,
        },
        computed: {
            ...mapState('discountRateComparison', [
                'discountRatesOptions'
            ]),
            DiscountRatesOptions: {
                get() {
                    return this.discountRatesOptions;
                },
                set(value) {
                    this.update({ key: 'discountRatesOptions', value });
                },
            },
        },
        methods: {
            ...mapActions('discountRateComparison', [
                'update',
            ]),
        }
    }
</script>



// WEBPACK FOOTER //
// DiscountRateOptions.vue?66696937